import { render, staticRenderFns } from "./RuleCampaigns.vue?vue&type=template&id=fc402972"
import script from "./RuleCampaigns.vue?vue&type=script&lang=js"
export * from "./RuleCampaigns.vue?vue&type=script&lang=js"
import style0 from "./RuleCampaigns.vue?vue&type=style&index=0&id=fc402972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports